export default "__VITE_ASSET__65t1738L__";